/** Convert an article category to a URL-safe slug */
export function categoryToSlug(category: string): string {
  return category
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

/** Build the full URL path for an article */
export function getArticleUrl(article: { category: string; slug: string }): string {
  return `/news/${categoryToSlug(article.category)}/${article.slug}`;
}
